import { ViewCountKeyEnum } from '@ztechapps/common.contract'
import { useViewCount, type UseViewCountResult } from '@ztechapps/common.hook'

/**
 * Hook for managing Task view counts.
 * Automatically increments the view count when the task is viewed.
 *
 * @param taskId - The ID of the task
 * @returns viewCount, increment, loading, error
 *
 * @example
 * const { viewCount } = useTaskViewCount(taskId)
 */
export function useTaskViewCount(taskId: string): UseViewCountResult {
  return useViewCount({
    key: ViewCountKeyEnum.Task,
    value: taskId,
  })
}
